import React from "react";
import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";
import TwoFASection from "../components/TwoFASection";

export default function Securite() {
  return (
    <Layout>
      <div className="p-6 md:p-10 max-w-[900px] mx-auto">
        <PageHeader
          kicker="Mon compte"
          title="Sécurité"
          subtitle="Renforcez la sécurité de votre compte en activant l'authentification à deux facteurs."
        />
        <TwoFASection />
      </div>
    </Layout>
  );
}
